<template>
  <div class="create-level">
    <div class="container" v-if="level.questions.length == 0 && level.unity.area.id != 3">
      <div class="title">
        <h1>Crear Nivel</h1>
        <p style="margin: 0; color: var(--another-grey);">Las preguntas y respuestas son obligatorias. Las imágenes son
          opcionales.</p>
        <button class="button button2" @click="showDialog('sureDialog')">Crear</button>
      </div>
      <div class="questions" v-for="(question, iq) in questions" :key="iq">
        <div class="question">
          <div class="container-question">
            <div class="questions-header">
              <div class="first-header">
                <i class="fa-solid fa-ellipsis"></i>
                <h2>{{ iq + 1 }}. Ingrese una pregunta: </h2>
              </div>
              <i class="fa-solid fa-x header-button" @click="deleteQuestionInIndex(iq)"></i>
            </div>
            <div class="form-group">
              <input type="text" placeholder="Pregunta" autocomplete="off" v-model="question.questionIndex">
            </div>
            <div class="answers" v-for="(item, i) in question.answers" :key="i">
              <div class="grab-header">
                <div class="first-header">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                  <h2>{{ i + 1 }}</h2>
                </div>
                <i class="fa-solid fa-x header-button" @click="deleteAnswerInIndex(iq, i)"></i>
              </div>
              <div class="grab-answers-form">
                <div class="form-group">
                  <input type="text" placeholder="Respuesta" autocomplete="off" v-model="item.answerIndex">
                  <label>
                    <input type="radio" v-model="item.valid" :value="true" @change="onAnswerSelection(item)">
                    V
                  </label>
                  <label>
                    <input type="radio" v-model="item.valid" :value="false" @change="onAnswerSelection(item)">
                    F
                  </label>
                </div>
                <div class="form-group">
                  <input type="text" placeholder="Url Imagen" autocomplete="off" v-model="item.urlToImage">
                </div>
              </div>
            </div>
            <button class="button" @click="newAnswer(iq)" v-if="question.answers.length != 3">Añadir respuesta</button>
          </div>
        </div>
        <button class="button" @click="newQuestion()" v-if="iq + 1 == questions.length">Añadir pregunta</button>
      </div>
      <button class="button button-alone" @click="newQuestion()" v-if="questions.length == 0">Añadir pregunta</button>
    </div>

    <div class="container" v-else-if="level.questions.length != 0 && level.unity.area.id != 3">
      <div class="title">
        <h1>Editar Nivel</h1>
        <button class="button button2" style="background-color: var(--red);"
          @click="showDialog('deleteDialog')">Eliminar</button>
        <button class="button button2" @click="showDialog('editDialog')">Editar</button>
      </div>
      <div class="questions" v-for="(question, iq) in level.questions" :key="iq">
        <div class="question">
          <div class="container-question">
            <div class="questions-header">
              <div class="first-header">
                <i class="fa-solid fa-ellipsis"></i>
                <h2>{{ iq + 1 }}. Pregunta: </h2>
              </div>
            </div>
            <div class="form-group">
              <input type="text" placeholder="Pregunta" autocomplete="off" v-model="question.questionIndex">
            </div>
            <div class="answers" v-for="(item, i) in question.answers" :key="i">
              <div class="grab-header">
                <div class="first-header">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                  <h2>{{ i + 1 }}</h2>
                </div>
              </div>
              <div class="grab-answers-form">
                <div class="form-group">
                  <input type="text" placeholder="Respuesta" autocomplete="off" v-model="item.answerIndex">
                  <label>
                    <input type="radio" v-model="item.valid" :value="true" @change="onAnswerSelection(item)">
                    V
                  </label>
                  <label>
                    <input type="radio" v-model="item.valid" :value="false" @change="onAnswerSelection(item)">
                    F
                  </label>
                </div>
                <div class="form-group">
                  <input type="text" placeholder="Url Imagen" autocomplete="off" v-model="item.urlToImage">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-else-if="level.questions.length == 0 && level.unity.area.id == 3">
      <div class="title">
        <h1>Crear Nivel</h1>
        <p style="margin: 0; color: var(--another-grey);">Las preguntas son obligatorias</p>
        <button class="button button2" @click="showDialog('sureDialogForSpeaking')">Crear</button>
      </div>
      <div class="questions" v-for="(question, iq) in questions" :key="iq">
        <div class="question">
          <div class="container-question">
            <div class="questions-header">
              <div class="first-header">
                <i class="fa-solid fa-ellipsis"></i>
                <h2>{{ iq + 1 }}. Ingrese una pregunta: </h2>
              </div>
              <i class="fa-solid fa-x header-button" @click="deleteQuestionInIndex(iq)"></i>
            </div>
            <div class="form-group">
              <input type="text" placeholder="Pregunta" autocomplete="off" v-model="question.questionIndex">
            </div>
          </div>
        </div>
        <button class="button" @click="newQuestion()" v-if="iq + 1 == questions.length">Añadir pregunta</button>
      </div>
      <button class="button button-alone" @click="newQuestion()" v-if="questions.length == 0">Añadir pregunta</button>
    </div>

    <div class="container" v-else-if="level.questions.length != 0 && level.unity.area.id == 3">
      <div class="title">
        <h1>Editar Nivel</h1>
        <button class="button button2" style="background-color: var(--red);"
          @click="showDialog('deleteDialog')">Eliminar</button>
        <button class="button button2" @click="showDialog('editDialogForSpeaking')">Editar</button>
      </div>
      <div class="questions" v-for="(question, iq) in level.questions" :key="iq">
        <div class="question">
          <div class="container-question">
            <div class="questions-header">
              <div class="first-header">
                <i class="fa-solid fa-ellipsis"></i>
                <h2>{{ iq + 1 }}. Pregunta: </h2>
              </div>
            </div>
            <div class="form-group">
              <input type="text" placeholder="Pregunta" autocomplete="off" v-model="question.questionIndex">
            </div>
          </div>
        </div>
      </div>
    </div>

    <dialog id="sureDialog">
      <p>¿Crear Nivel?</p>
      <div class="dialog-flex">
        <button class="button button2" style="background-color: var(--red);"
          @click="closeDialog('sureDialog')">Cancelar</button>
        <button class="button button2" @click="startPostLevel()">Aceptar</button>
      </div>
    </dialog>

    <dialog id="sureDialogForSpeaking">
      <p>¿Crear Nivel?</p>
      <div class="dialog-flex">
        <button class="button button2" style="background-color: var(--red);"
          @click="closeDialog('sureDialogForSpeaking')">Cancelar</button>
        <button class="button button2" @click="postOnlyQuestions()">Aceptar</button>
      </div>
    </dialog>

    <dialog id="editDialog">
      <p>¿Editar Nivel?</p>
      <div class="dialog-flex">
        <button class="button button2" style="background-color: var(--red);"
          @click="closeDialog('editDialog')">Cancelar</button>
        <button class="button button2" @click="startPutQuestionsAndAnswers()">Aceptar</button>
      </div>
    </dialog>

    <dialog id="editDialogForSpeaking">
      <p>¿Editar Nivel?</p>
      <div class="dialog-flex">
        <button class="button button2" style="background-color: var(--red);"
          @click="closeDialog('editDialogForSpeaking')">Cancelar</button>
        <button class="button button2" @click="putOnlyQuestions()">Aceptar</button>
      </div>
    </dialog>

    <dialog id="deleteDialog">
      <p>¿Eliminar nivel?</p>
      <div class="dialog-flex">
        <button class="button button2" style="background-color: var(--red);"
          @click="closeDialog('deleteDialog')">Cancelar</button>
        <button class="button button2" @click="deleteLevel()">Aceptar</button>
      </div>
    </dialog>

    <dialog id="completeDialog">
      <p>Acción completada</p>
      <div class="dialog-flex">
        <button class="button button2" @click="returnPage()">Regresar</button>
      </div>
    </dialog>


    <dialog id="errorDialog">
      <p>Acción completada</p>
      <div class="dialog-flex">
        <button class="button button2" style="background-color: var(--red);"
          @click="closeDialog('errorDialog')">Regresar</button>
      </div>
    </dialog>

  </div>
</template>
          
<script>
import router from "@/router";

export default {
  name: "CreateLevelView",
  data() {
    return {
      errorDialog: null,
      completeDialog: null,
      editDialogForSpeaking: null,
      editDialog: null,
      sureDialogForSpeaking: null,
      sureDialog: null,
      deleteDialog: null,
      level: null,
      questions: [{ questionIndex: '', answers: [] }],
    };
  },
  mounted() {
    this.getLevel();
  },
  methods: {
    newQuestion() {
      this.questions.push({ questionIndex: '', answers: [] });
    },
    newAnswer(index) {
      this.questions[index].answers.push({ answerIndex: '', valid: false, urlToImage: '' });
    },
    deleteQuestionInIndex(index) {
      this.questions.splice(index, 1);
    },
    deleteAnswerInIndex(indexQ, indexA) {
      this.questions[indexQ].answers.splice(indexA, 1);
    },
    onAnswerSelection(indexQ, indexA, answerValid) {
      this.questions[indexQ].answers[indexA].valid = answerValid;
    },
    goToRoute(route) {
      router.push("/" + route);
    },
    showDialog(dialog) {
      this[dialog] = document.getElementById(dialog);
      this[dialog].showModal();
    },
    closeDialog(dialog) {
      this[dialog].close();
    },
    returnPage() {
      this.$router.go(-1);
    },
    /*SERVICES*/
    async getLevel() {
      try {
        const response = await this.$axios.get(
          "levels/" + this.$route.params.id
        );
        console.log("Respuesta del servidor:", response.data);
        this.level = response.data;
      } catch (error) {
        console.error("Error al realizar la solicitud GET:", error);
      }
    },
    startPostLevel() {
      const questionIndexes = this.questions
        .filter(question => question.questionIndex !== '' && question.answers.some(answer => answer.answerIndex !== '')) // Filtrar por questionIndex no vacío y answers no vacías
        .map(question => ({ questionIndex: question.questionIndex }));
      const answersArrays = this.questions
        .filter(question => question.answers.length > 0) // Filtrar preguntas con answers
        .filter(question => question.questionIndex !== '') // Filtrar por questionIndex no vacío
        .map(question => question.answers.filter(answer => answer.answerIndex !== ''));

      if (questionIndexes.length != 0 && answersArrays.length != 0) {
        this.postQuestions(questionIndexes, answersArrays);
      }
      else {
        console.log("No hay preguntas o respuestas")
      }
    },
    async postQuestions(questionIndex, answerIndex) {
      try {
        const response = await this.$axios.post(
          "questions/" +
          this.$route.params.id,
          questionIndex,
        );

        this.postAnswers(response.data, answerIndex);
      } catch (error) {
        this.errorDialog = document.getElementById("errorDialog");
        this.errorDialog.showModal();
      }
    },
    async postAnswers(createdQuestions, answerIndex) {
      for (let index = 0; index < createdQuestions.length; index++) {
        try {
          await this.$axios.post(
            "answers/" +
            createdQuestions[index].id,
            answerIndex[index],
          );
          this.completeDialog = document.getElementById("completeDialog");
          this.completeDialog.showModal();
        } catch (error) {
          this.errorDialog = document.getElementById("errorDialog");
          this.errorDialog.showModal();
        }
      }


    },
    async postOnlyQuestions() {
      const questionIndexes = this.questions
        .filter(question => question.questionIndex !== '') // Filtrar por questionIndex no vacío y answers no vacías
        .map(question => ({ questionIndex: question.questionIndex }));

      if (questionIndexes.length != 0) {
        try {
          await this.$axios.post(
            "questions/" +
            this.$route.params.id,
            questionIndexes,
          );
          this.completeDialog = document.getElementById("completeDialog");
          this.completeDialog.showModal();
        } catch (error) {
          this.errorDialog = document.getElementById("errorDialog");
          this.errorDialog.showModal();
        }

      }
      else {
        console.log("No hay preguntas o respuestas")
      }
    },
    async putOnlyQuestions() {
      const questionIndexes = this.level.questions
        .filter(question => question.questionIndex !== '') // Filtrar por questionIndex no vacío y answers no vacías
        .map(question => ({ id: question.id, questionIndex: question.questionIndex }));

      if (questionIndexes.length != 0) {
        try {
          await this.$axios.put(
            "questions",
            questionIndexes,
          );
          this.completeDialog = document.getElementById("completeDialog");
          this.completeDialog.showModal();
        } catch (error) {
          this.errorDialog = document.getElementById("errorDialog");
          this.errorDialog.showModal();
        }

      }
      else {
        console.log("No hay preguntas o respuestas")
      }
    },
    startPutQuestionsAndAnswers() {
      const questionIndexes = this.level.questions
        .filter(question => question.questionIndex !== '' && question.answers.some(answer => answer.answerIndex !== '')) // Filtrar por questionIndex no vacío y answers no vacías
        .map(question => ({ id: question.id, questionIndex: question.questionIndex }));
      const answersArrays = this.level.questions
        .filter(question => question.answers.length > 0 && question.questionIndex !== '') // Filtrar preguntas válidas
        .flatMap(question => question.answers.filter(answer => answer.answerIndex !== '')); // Convertir a un solo arreglo de Answer2

      if (questionIndexes.length != 0 && answersArrays.length != 0) {
        this.putQuestions(questionIndexes, answersArrays);
      }
      else {
        console.log("No hay preguntas o respuestas")
      }
    },
    async putQuestions(questionIndex, answerIndex) {
      try {
        await this.$axios.put(
          "questions",
          questionIndex,
        );

        this.putAnswers(answerIndex);

      } catch (error) {
        this.errorDialog = document.getElementById("errorDialog");
        this.errorDialog.showModal();
      }
    },
    async putAnswers(answerIndex) {
      try {
        await this.$axios.put(
          "answers",
          answerIndex,
        );
        this.completeDialog = document.getElementById("completeDialog");
        this.completeDialog.showModal();
      } catch (error) {
        this.errorDialog = document.getElementById("errorDialog");
        this.errorDialog.showModal();
      }


    },
    async deleteLevel() {
      try {
        await this.$axios.delete(
          "levels/" + this.$route.params.id,
        );
        this.completeDialog = document.getElementById("completeDialog");
        this.completeDialog.showModal();
      } catch (error) {
        this.errorDialog = document.getElementById("errorDialog");
        this.errorDialog.showModal();
      }

    }
  },
};
</script>
        
<style scoped>
.create-level {
  flex: 1;
  background-color: var(--not-so-grey);
}

.container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.title {
  padding: 2rem 2rem 1.5rem 1rem;
  border-bottom: 1px solid var(--another-grey);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title h1 {
  color: var(--main-color);
  margin: 0;
}

/*QUESTIONS*/

.questions {
  margin: 20px 0 10px 0;
  display: flex;
  flex-direction: column;
}

.question {
  margin: 20px;
  background-color: var(--not-so-grey);
  border-radius: 18px;
  -webkit-border-radius: 18px;
  -moz-border-radius: 18px;
  -ms-border-radius: 18px;
  -o-border-radius: 18px;
}

.container-question {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/*QUESTION HEADER*/

.questions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.first-header {
  display: flex;
  gap: 20px;
  align-items: center;
}

.grab-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.first-header h2 {
  font-size: 20px;
}

.header-button {
  transition: all ease-out 0.2s;
  -webkit-transition: all ease-out 0.2s;
  -moz-transition: all ease-out 0.2s;
  -ms-transition: all ease-out 0.2s;
  -o-transition: all ease-out 0.2s;
}

.header-button:hover {
  color: var(--red);
  cursor: pointer;
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
}

/*QUESTION CONTENT*/

.form-group {
  display: flex;
  flex: 1;
  background-color: var(--light-grey);
  border: 1px solid var(--grey);
  padding: 10px 0;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  transition: all ease-out 0.2s;
  -webkit-transition: all ease-out 0.2s;
  -moz-transition: all ease-out 0.2s;
  -ms-transition: all ease-out 0.2s;
  -o-transition: all ease-out 0.2s;
}

.form-group:hover {
  border: 1px solid var(--main-color);
  box-shadow: 0 0 5px #6c63ff;
}

.form-group input {
  flex: 1;
  padding: 15px 0;
  margin-left: 10px;
  margin-right: 10px;
  background-color: var(--light-grey);
  border: none;
  outline: none;
  font-size: 18px;
}

.form-group label {
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*BUTTONS*/

.button {
  align-self: flex-end;
  margin: 10px 0;
  background-color: transparent;
  color: var(--main-color);
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 18px;
  letter-spacing: 1.2px;
  transition: all ease-out 0.2s;
  -webkit-transition: all ease-out 0.2s;
  -moz-transition: all ease-out 0.2s;
  -ms-transition: all ease-out 0.2s;
  -o-transition: all ease-out 0.2s;
}

.button:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}

.button2 {
  background-color: var(--main-color);
  color: var(--white);
  border-radius: 18px;
  -webkit-border-radius: 18px;
  -moz-border-radius: 18px;
  -ms-border-radius: 18px;
  -o-border-radius: 18px;
}

.button-alone {
  align-self: center;
}

.radio-group {
  margin-right: 10px;
}


.buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/*ANSWERS*/

.answers {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  color: var(--another-grey);
}

.grab-answers-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.answers .form-group {
  width: 100%;
  padding: 5px;
}

.answers .form-group input {
  flex: 1;
  padding: 10px 0;
  margin-left: 10px;
  margin-right: 10px;
  background-color: var(--light-grey);
  border: none;
  outline: none;
  font-size: 16px;
}

dialog {
  border: none !important;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 2rem;
}

dialog p {
  font-size: 20px;
}

.dialog-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

@media (max-width: 900px) {
  .title {
    flex-direction: column;
    gap: 1rem;
  }

  .title h1 {
    text-align: center;
  }

  .buttons {
    flex-direction: column;
  }
}
</style>